import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Tooltip from "@material-ui/core/Tooltip";
import {
  KeyboardBackspace,
} from "@material-ui/icons";
import { logout } from "../utils/auth";
import { routes } from "../Routes/RoutesName";
import logo from '../Assets/riwa-admin-logo.svg'
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  listItemText: {
    fontFamily: "Poppins",
  },

  
  selectedLink: {
    display:"block",


    width: "56px",
    background: "#e7e7e7"
  },

}));

export default function Sidebar({ Loading, Permissions }) {

  


  const classes = useStyles();
  const theme = useTheme();
  const history = useNavigate();
  const location=useLocation()


  const [open, setOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
	const isAdmin = localStorage.getItem('uid')

  const isAdminFunc = async() =>{
    const docRef = await getDoc(doc(db,'AppInfo','settings'));
    if(isAdmin != docRef.data().admin_uid){
    history({ pathname: "/" })
  }
    return null
  
  }
    useEffect(()=> {
      isAdminFunc()
    }, [isAdmin]);
  let newRoutes;
  if (routes) {
    // console.log(Permissions, routes)
    // newRoutes = routes.filter(item => Permissions.includes(item.title) && item)
    // // console.log(a)
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        elevation={0}
        position='fixed'
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}>
        <Toolbar>
          <IconButton
            // color='#fff'
            aria-label='open drawer'
            onClick={handleDrawerOpen}
            edge='start'
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}>
            <MenuIcon style={{ color: " #fff" }} />
          </IconButton>
          <div className='sidebar-head'>
            {/* <img src={logo} style={{ width: '70px' }} /> */}
            <p style={{color:'#fff',fontSize:'22px',fontWeight:'bold'}}>Kalamazoo Admin Panel</p>
          </div>
        </Toolbar>
      </AppBar>
      {!Loading && (
        <Drawer
          variant='permanent'
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}>
          <div className={classes.toolbar}>
            <IconButton onClick={handleDrawerClose} sx={{
              "& .MuiIconButton-edgeStart": {
                marginLeft: '-30px'
              },
              "& .MuiSvgIcon-root": {
                width: '100px',
              }

            }}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </div>
          <Divider />

          <List style={{ minHeight: "110vh" }}>
            {routes.map((route, ind) => {
              return (
                <Link
               
                  // Permissions.includes("Admins") && (
                  onClick={handleDrawerClose}
                  
                 

                   className={`links ${location.pathname === `/dashboard/${route.name.toLowerCase()}` ? classes.selectedLink : ""}`}

                

                  to={"/dashboard/" + route.name.toLowerCase()}>

                    {/* {
                      console.log(  location.pathname ==  `/dashboard/${route.name.toLowerCase()}`)
                    }

                        {
                      console.log( `/dashboard/${route.name.toLowerCase()}`)
                    }

                      {
                      console.log(   location.pathname)
                    } */}
                   

  
                   
                  <Tooltip
                    title={route.title}
                    disableHoverListener={open}
                    placement='bottom-end'>
                    <ListItem style={{ marginTop: "15px" }} button>
                      {route?.src?
                      <>
                      <img src={route?.src} style={{width:'27px'}}/>                      
                      </>
                    :
                    <ListItemIcon>{route.icon}</ListItemIcon>
                  }
                      <p className='list-item' style={{marginLeft:route?.src?'25px':'0px'}}>{route.title}</p>
                    </ListItem>
                  </Tooltip>
                </Link>
              );
              // )
            })}

           
            <div className='links logout'>
              <Tooltip title='Logout' disableHoverListener={open}>
                <ListItem
                  onClick={() => logout(history)}
                  style={{ marginTop: "15px" }}
                  button>
                  <ListItemIcon>
                    <KeyboardBackspace />
                  </ListItemIcon>
                  <p className='list-item'>Logout</p>
                </ListItem>
              </Tooltip>
            </div>
          </List>
        </Drawer>
      )}
    </div>
  );
}
